import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { m as merge } from '../../unsorted/index.js';
import { _ as _taggedTemplateLiteral } from '../../unsorted/taggedTemplateLiteral.js';
import { keyframes } from '@emotion/react';
import { jsx } from '@emotion/react/jsx-runtime';
import { B as Box } from '../Box/Box.js';

var _templateObject;
var gradientWipe = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["100% { mask-position: left }"])));
var shimmerSx = {
  display: "block",
  width: "100%",
  height: "100%",
  bgi: "base.gradient.1",
  mask: "linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/400% 100%",
  brad: "base.borderRadius.x2",
  backgroundRepeat: "no-repeat",
  animation: "".concat(gradientWipe, " 1.3s infinite"),
  opacity: 0.32,
  minw: "10px",
  minh: "5px"
};

var _excluded = ["sx"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ShimmerBox(_ref) {
  var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(Box, _objectSpread(_objectSpread({}, props), {}, {
    sx: merge(shimmerSx, sx)
  }));
}

export { ShimmerBox as S, shimmerSx as s };
//# sourceMappingURL=ShimmerBox.js.map
